//headshots format ->initals+hs (headshot), except alumni, 
//alumni
// founding
import jeanchoiheadshot from './images/BrotherHeadshots/Alumni/jeanchoiheadshot.jpg';
import justintranheadshot from './images/BrotherHeadshots/Alumni/justintranheadshot.jpg';
import michaelyiuheadshot from './images/BrotherHeadshots/Alumni/michaelyiuheadshot.jpg';
import audreyhoangheadshot from './images/BrotherHeadshots/Alumni/audreyhoangheadshot.jpg';
import tylerlinheadshot from './images/BrotherHeadshots/Alumni/tylerlinheadshot.jpg';
import emmastrambergheadshot from './images/BrotherHeadshots/Alumni/emmastrambergheadshot.jpg';
import colemarinheadshot from './images/BrotherHeadshots/Alumni/colemarinheadshot.jpg';
import ashparasaheadshot from './images/BrotherHeadshots/Alumni/ashparasaheadshot.jpg';
import spencerflynnheadshot from './images/BrotherHeadshots/Alumni/spencerflynnheadshot.jpg';
import khanhthyleheadshot from './images/BrotherHeadshots/Alumni/khanhthyleheadshot.jpg';
import joeylombardoheadshot from './images/BrotherHeadshots/Alumni/joeylombardoheadshot.jpg';
import anushreeparmarheadshot from './images/BrotherHeadshots/Alumni/anushreeparmarheadshot.jpg';
import melvintabiosheadshot from './images/BrotherHeadshots/Alumni/melvintabiosheadshot.jpg';
import vincentchenheadshot from './images/BrotherHeadshots/Alumni/vincentchenheadshot.jpg';

//alpha
import gabrielhyunheadshot from './images/BrotherHeadshots/Alumni/gabrielhyunheadshot.jpg';
import jordanrossheadshot from './images/BrotherHeadshots/Alumni/jordanrossheadshot.jpg';
import sabrinanguyenheadshot from './images/BrotherHeadshots/Alumni/sabrinanguyenheadshot.jpg';
import carolinephamheadshot from './images/BrotherHeadshots/Alumni/carolinephamheadshot.jpg';
import jbrhs from './images/BrotherHeadshots/Alpha/jadonbradfordheadshot.jpg';
import adhs from './images/BrotherHeadshots/Alpha/alexisdigregorioheadshot.jpg';
import shhs from './images/BrotherHeadshots/Alpha/skylerhanheadshot.jpg';
import clhs from './images/BrotherHeadshots/Alpha/carloslopezheadshot.jpg';
//beta
import nmhs from './images/BrotherHeadshots/Beta/noellemarroquin.png';
import xphs from './images/BrotherHeadshots/Beta/xavierapons.png';
import trhs from './images/BrotherHeadshots/Beta/tanarisley.png';
//import srhs from './images/BrotherHeadshots/Beta/shannonrobinson.jpg';
import bshs from './images/BrotherHeadshots/Beta/bellashaffer.png';
import rwhs from './images/BrotherHeadshots/Beta/reesewheeler.JPG';
//Gamma
import nghs from './images/BrotherHeadshots/Gamma/NickGhaffarianHeadshot.png';

//beta
//soren(?)

//active

//delta
import jbuhs from './images/BrotherHeadshots/Delta/JasmineBuenoHeadshot.jpeg';
// import achs from './images/BrotherHeadshots/Delta/AbbyCarterHeadshot.jpeg';
import achs2 from './images/BrotherHeadshots/Delta/AbbyCarterHeadshot2.jpg';
// import rfhs from './images/BrotherHeadshots/Delta/RaquelFujitaHeadshot.png';
// import vghs from './images/BrotherHeadshots/Delta/VanessaGuzmanHeadshot.png';
import sphs from './images/BrotherHeadshots/Delta/SakikoPizzornoHeadshot.jpg';
import cuhs from './images/BrotherHeadshots/Delta/CadenUpsonHeadshot.jpg';
import evhs from './images/BrotherHeadshots/Delta/EmilyVuongHeadshot.jpg';
// import jzhs from './images/BrotherHeadshots/Delta/JanetZavala-AlborHeadshot.jpg';
//Epsilon
import sahs from './images/BrotherHeadshots/Epsilon/ShafiqAmatHeadshot.jpg';
//import jdhs from './images/BrotherHeadshots/Epsilon/JackDevereuxHeadshot.JPEG';
import dghs from './images/BrotherHeadshots/Epsilon/DominiqueGiangHeadshot.jpg';
import anhs from './images/BrotherHeadshots/Epsilon/AvaNgoHeadshot.jpg';
import iphs from './images/BrotherHeadshots/Epsilon/IzabellaPargaHeadshot.jpeg';
import aphs from './images/BrotherHeadshots/Epsilon/AidenPhanHeadshot.png';
import prhs from './images/BrotherHeadshots/Epsilon/PaigeReadHeadshot.jpg';
import erhs from './images/BrotherHeadshots/Epsilon/EvanRussellHeadshot.png';
import jyhs from './images/BrotherHeadshots/Epsilon/JodiYamaneHeadshot.jpeg';
//Zeta
import salhs from './images/BrotherHeadshots/Zeta/SuhanthAlluriHeadshot.png';
// import jnhs from './images/BrotherHeadshots/Zeta/JasmineNgHeadshot.png';
import mshs from './images/BrotherHeadshots/Zeta/MaxwellSilverHeadshot.png';
import wths from './images/BrotherHeadshots/Zeta/WillTollHeadshot.jpeg';
// import avhs from './images/BrotherHeadshots/Zeta/AlexValenzanoHeadshot.jpeg';
import alhs from './images/BrotherHeadshots/Zeta/ArianneLandersHeadShot.jpg';
//Eta
import msuhs from './images/BrotherHeadshots/Eta/MatthewSubanHeadshot3.png';
import crhs from './images/BrotherHeadshots/Eta/ClaireRissHeadshot.jpg';
import pehs from './images/BrotherHeadshots/Eta/ParkerEvansHeadshot.jpg';
import dahs from './images/BrotherHeadshots/Eta/DevAmudalaHeadshot.jpg';
import chhs from './images/BrotherHeadshots/Eta/ChrisHawleyHeadshot.jpeg';
import aehs from './images/BrotherHeadshots/Eta/AlonzoEdwardsHeadshot.jpeg';
import aprhs from './images/BrotherHeadshots/Eta/AnaPrasadHeadshot.jpg';
import dkhs from './images/BrotherHeadshots/Eta/DevlinKnillHeadshot.jpg';
import hdhs from './images/BrotherHeadshots/Eta/HongDangHeadshot.jpg';
//Iota
import mahs from './images/BrotherHeadshots/Iota/MaiyaArmstrongHeadshot.jpg';
import nkhs from './images/BrotherHeadshots/Iota/NicoleKaldasHeadshot.jpg';
import gshs from './images/BrotherHeadshots/Iota/GabiSandsHeadshot.jpg';
// import nths from './images/BrotherHeadshots/Iota/NimishaThakurHeadshot.jpg';
import kbhs from './images/BrotherHeadshots/Iota/KatherineBicoccaHeadshot2.jpg';
import tchs from './images/BrotherHeadshots/Iota/ThomasCostaHeadshot.jpg';
import izhs from './images/BrotherHeadshots/Iota/IzzyZastrowHeadshot.jpg';
import jihs from './images/BrotherHeadshots/Iota/JackIsolaHeadshot.jpeg';
//Theta
import brhs from './images/BrotherHeadshots/Theta/BellaRiveraHeadshot.jpg';
// import ychs from './images/BrotherHeadshots/Theta/YaneliCruzHeadshot.jpg';
//Kappa
import bahs from './images/BrotherHeadshots/Kappa/BarrettAbenaHeadshot.jpg';
import mshs2 from './images/BrotherHeadshots/Kappa/MonicaSebastianHeadshot.jpg';
import nshs from './images/BrotherHeadshots/Kappa/NaomiSabesHeadshot.jpg';
import sphs2 from './images/BrotherHeadshots/Kappa/SethPoulterHeadshot.jpg';
import kghs from "./images/BrotherHeadshots/Kappa/KarolinaGutierrezHeadshot.jpeg";


import annawilsonheadshot from './images/BrotherHeadshots/Zeta/AnnaWilsonHeadshot.jpg';
import akhiladonthiheadshot from './images/BrotherHeadshots/Zeta/AkhilaDonthiHeadshot.jpg';
import carlosmanzanoheadshot from './images/BrotherHeadshots/Eta/CarlosManzanoHeadshot.jpg';
import vinayakkohliheadshot from './images/BrotherHeadshots/Eta/VinayakKohliHeadshot.jpg';
import samrodriguezheadshot from './images/BrotherHeadshots/Theta/SamRodriguezHeadshot.jpg';
import alexazamoraheadshot from './images/BrotherHeadshots/Theta/AlexaZamoraHeadshot.jpg';
import stephaniejovelheadshot from './images/BrotherHeadshots/Theta/StephanieJovelHeadshot.jpg';
import allegraciarlantiniheadshot from './images/BrotherHeadshots/Iota/AllegraCiarlantiniHeadshot.jpg';
import brycewangheadshot from './images/BrotherHeadshots/Iota/BryceWangHeadshot.jpg';
import zackadzichheadshot from './images/BrotherHeadshots/Kappa/ZackAdzichHeadshot.jpg';
import noemialatorreheadshot from './images/BrotherHeadshots/Kappa/NoemiAlatorreHeadshot.jpg';
import marilinrodriguezheadshot from './images/BrotherHeadshots/Iota/MarilinRodriguezHeadshot.jpg';
import yanelicruzheadshot2 from './images/BrotherHeadshots/Theta/YaneliCruzHeadshot2.jpg';
import snehilkakaniheadshot from './images/BrotherHeadshots/Kappa/SnehilKakaniHeadshot.jpg';
import mirandareyesheadshot from './images/BrotherHeadshots/Iota/MirandaReyesHeadshot.jpg';
import alexvalenzanoheadshot2 from './images/BrotherHeadshots/Zeta/AlexValenzanoHeadshot2.jpg';
import colehoppheadshot from './images/BrotherHeadshots/Iota/ColeHoppHeadshot.jpeg';
import nimishathakurheadshot2 from './images/BrotherHeadshots/Iota/NimishaThakurHeadshot2.jpg';
import sophiamccartneyheadshot from './images/BrotherHeadshots/Kappa/SophiaMcCartneyHeadshot.jpg';
//profile pictures

//resumes
import rwr from './images/BrotherResumes/reesewheelerresume.pdf'
import jyr from './images/BrotherResumes/JodiYamaneresume.pdf';

// empty experience object to copy and paste {year: '', company: '', position: ''},
export const Alum = [ // huge array containing all the brother objects (make use of VS Code 'fold' feature for an easier life)
  { // Jean Choi
    id: '0',
    gender: 'f',
    name: 'Jean Choi',
    major: ['Statistics', 'STAT'],
    minor: '',
    headshot: jeanchoiheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/jean-choi-cp/',
    resume: 'https://drive.google.com/file/d/1eGFNyyyn5ImUnhfeAfhfYBu2RB983W1K/view?usp=sharing',
    campusInvolvement: 'SLO Hacks, Data Science Fellowship, KASA, Stats Club, Google Developer Club, Spec',
    experience: [
      {year: '2020', company: 'National Science Foundation', position: 'Data Science Fellow'},
      {year: '2020', company: 'Cal Poly SLO Software and Computer Engineering Department', position: 'Data Analytics Research Assistant'},
      {year: '2019-2020', company: 'Cal Fresh', position: 'Data Analytics Intern'},
    ],
    interestHobbies: 'Taekwondo, Soccer, Baking, Traveling',
    funFact: 'I am a second degree black belt in taekwondo'
  },
  { //Justin Tran
    id: '1',
    gender: 'm',
    name: 'Justin Tran',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: justintranheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/justin-tran-a4848a183/',
    resume: 'https://drive.google.com/file/d/1sw1ePl9SVEUixRaOEe3QXkfBuLsMB3yC/view?usp=sharing',
    campusInvolvement: 'Information Systems Association, Computer Engineering Society, Korean American Student Association',
    experience: [
      {year: '2020', company: 'Exploratorium', position: 'Digital Content Creator'},
      {year: '2020', company: 'Trees', position: 'Product Design Intern'},
    ],
    interestHobbies: 'Spending too much time on Spotify & being bad at basketball :(',
    funFact: 'Bladee turned the crib to the club'
  },
  { // Michael Yiu
    id: '2',
    gender: 'm',
    name: 'Michael Yiu',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: michaelyiuheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/michaelw-yiu/',
    resume: 'https://drive.google.com/file/d/1eNTb3Nq6mYdeTvNIKvzZAlJpFo-x7rR4/view?usp=sharing',
    campusInvolvement: 'American Society of Mechanical Engineers, Northrop Grumman Collaboration, CP Scholars, KASA',
    experience: [
      {year: '2019-Present', company: 'Cal Poly Scholars', position: 'Events Coordinator'},
    ],
    interestHobbies: 'Cooking, Knitting, Picnicking, Watching the sunset at a beach',
    funFact: 'I originally wanted to be a history major!'
  },
  { // Audrey Hoang
    id: '3',
    gender: 'f',
    name: 'Audrey Hoang',
    major: ['Architectural Engineering', 'ARCE'],
    minor: '',
    headshot: audreyhoangheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/audrey-h-4249a6139/',
    resume: 'https://drive.google.com/file/d/1vxxCYLvjCfanqOOa5oLRwc20u5ip0H4U/view?usp=sharing',
    campusInvolvement: 'Structural Engineers Association of California, Chinese Student Association',
    experience: [
      {year: '2020-Present', company: 'e.l.f Cosmetics', position: 'Visual Merchandising Intern'},
      {year: '2020', company: 'Bay Engineering', position: 'Drafting Assistant'},
      {year: '2020', company: 'Cal Poly Department of Architectural Engineering', position: 'Marketing Intern'},
      {year: '2019', company: 'HKIT Architects', position: 'Design Intern'},
    ],
    interestHobbies: 'Digital & Film Photography, Architecture, Design, Playing the piano, Swimming',
    funFact: 'I swam competitively for 9 years!'
  },
  { // Tyler Lin
    id: '4',
    gender: 'm',
    name: 'Tyler Lin',
    major: ['Industrial Engineering', 'IME'],
    minor: '',
    headshot: tylerlinheadshot,
    class: 'Founding',
    linkedin: 'http://linkedin.com/in/tyleralin',
    resume: 'https://drive.google.com/file/d/1Qa1CsIBsJJXH39LElhF-3z-q03Z2yNUN/view?usp=sharing',
    campusInvolvement: 'Alpha Kappa Psi, Coca-Cola Campus Ambassador, PROVE Lab',
    experience: [],
    interestHobbies: 'Photography, Fashion, Travel',
    funFact: 'I love my corgi'
  },
  { // Emma Stramberg
    id: '5',
    gender: 'f',
    name: 'Emma Stramberg',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: emmastrambergheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/estrambe/',
    resume: 'https://drive.google.com/file/d/1wAjgEmyDFKZLOwPLI13-6wf1Zp2dj607/view?usp=sharing',
    campusInvolvement: 'Kappa Alpha Theta, Biomedical Engineering Society, Society of Women Engineers, New Student Transition Programs',
    experience: [
      {year: '2019', company: 'TreanorHL', position: 'Student Intern'},
    ],
    interestHobbies: 'Hammocking, Hiking, Surfing, Cooking and trying out new recipes',
    funFact: 'I grew up in the middle of the United States and it has encouraged me to want to visit all the states because everywhere has something to offer'
  },
  { // Cole Marin
    id: '6',
    gender: 'm',
    name: 'Cole Marin',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: colemarinheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/cole-marin/',
    resume: 'https://drive.google.com/file/d/1VCwO_ynfNr6nPlTFAoMJ3T4DCF9Ob1uT/view?usp=sharing',
    campusInvolvement: 'ASME, Supplemental Workshops in Science',
    experience: [
      {year: '2020', company: 'Cal Poly SLO M.E. Department', position: 'Student Researcher'},
      {year: '2019', company: 'Parker Aerospace', position: 'Quality Engineering Intern'},
    ],
    interestHobbies: 'Rock Climbing, Guitar, Motorcycles',
    funFact: 'I was born during a 7.1 magnitude earthquake!'
  },
  { //Ash Parasa
    id: '7',
    gender: 'm',
    name: 'Ash Parasa',
    major: ['Computer Science', 'CSC'],
    minor: 'Data Science',
    headshot: ashparasaheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/ashparasa',
    resume: 'https://drive.google.com/file/d/1FVyy-S_NXhbyU6AJIBf4HnTVI0jEri3n/view?usp=sharing',
    campusInvolvement: 'University Honors, Engineering Ambassadors, Data Science Fellowship, Research, Data Science Club',
    experience: [
      {year: '2021', company: 'Amazon', position: 'Software Development Intern'},
      {year: '2020', company: 'National Science Foundation', position: 'Data Science Research Fellow'},
      {year: '2020', company: 'CME Group', position: 'Software Engineering Intern'},
      {year: '2020', company: 'Harvard Medical School', position: 'Software Volunteer - COVID-19 Research'},
      {year: '2019-2020', company: 'Cal Poly Engineering', position: 'Research Assistant'},
      {year: '2019', company: 'Transitions-Mental Health Association', position: 'Full Stack Developer'},
      {year: '2019', company: 'US Army Research Laboratory', position: 'Machine Learning Research Intern'},
      {year: '2017-2018', company: 'Prudential Financial', position: 'Software Engineering Intern'},
    ],
    interestHobbies: 'Traveling, Hiking, Running, Gaming, Geography, Politics, Soccer',
    funFact: 'I learned how to code by making mods for Minecraft!'
  },
  { // Spencer Flynn
    id: '8',
    gender: 'm',
    name: 'Spencer Flynn',
    major: ['Materials Engineering', 'MATE'],
    minor: '',
    headshot: spencerflynnheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/spencer-flynn-ba72a3197/',
    resume: 'https://drive.google.com/file/d/18yzQ-kbGFesu8bPR6PQM3Phg19QSyLZG/view?usp=sharing',
    campusInvolvement: 'Future Fuels Club, Swim Club',
    experience: [],
    interestHobbies: 'Swimming, Basketball, Hiking, Reading, Golfing',
    funFact: 'I always eat all my fries before I eat my burger lol'
  },
  { // Khanhthy Le
    id: '9',
    gender: 'f',
    name: 'Khanhthy Le',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: khanhthyleheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/khanhthyle/',
    resume: 'https://drive.google.com/file/d/1UCc-MysEqG7wGsqh-DoQh_9cMU5835Ll/view?usp=sharing',
    campusInvolvement: 'Mustang Consulting, Cal Poly Hyperloop, alpha Kappa Delta Phi',
    experience: [
      {year: '2020', company: 'Mustang Consulting', position: 'Associate Consultant'},
      {year: '2018', company: 'Naprotek', position: 'Electronics Manufacturing Intern'},
    ],
    interestHobbies: 'Reading, Crafting, Learning new things!',
    funFact: 'I have two puppies from the same litter'
  },
  { // Joey Lombardo
    id: '10',
    gender: 'm',
    name: 'Joey Lombardo',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: joeylombardoheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/joey-lombardo/',
    resume: 'https://drive.google.com/file/d/1RC_tVrAfdLoTjBOaz_O-ZmuymU-HqlRZ/view?usp=sharing',
    campusInvolvement: 'American Society of Civil Engineers, Steel Bridge Club, Concrete Canoe Club, Engineers Without Borders, Inter Housing Council Senate',
    experience: [
      {year: '2018', company: 'Engineering Systems Solutions', position: 'Shadow'},
    ],
    interestHobbies: 'Mountain Biking, Snowboarding, Fishing, Camping, Hiking, Soccer',
    funFact: 'I\'m nice at ping pong'
  },
  { // Anushree Parmar
    id: '11',
    gender: 'f',
    name: 'Anushree Parmar',
    major: ['Computer Engineering', 'CPE'],
    minor: '',
    headshot: anushreeparmarheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/anushree-parmar/',
    resume: 'https://drive.google.com/file/d/1Ddu5WlXosHQWXtDM95MzrsfhB482mruO/view?usp=sharing',
    campusInvolvement: 'WISH, Hack4Impact, CS + SG, CPES, aKDPhi',
    experience: [],
    interestHobbies: 'Data Analytics, Web Design, Traveling, Cooking/Baking',
    funFact: ''
  },
  { // Melvin Tabios
    id: '12',
    gender: 'm',
    name: 'Melvin Tabios',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: melvintabiosheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/melvin-william-tabios-324551180/',
    resume: 'https://drive.google.com/file/d/1lnQoC3OP5akeIdqEn2nuZqu0HiecC25O/view?usp=sharing',
    campusInvolvement: 'Pilipino Cultural Exchange, United in Movement SLO',
    experience: [
      {year: '2018', company: 'Clark Construction Group', position: 'Construction Intern'},
    ],
    interestHobbies: 'Dance, Music, Basketball, Videogames',
    funFact: 'Before studying to become an engineer, for the longest time I\'ve always wanted to become a forensic scientist and help solve criminal cases. It wasn\'t until the summer before senior year of high school that I changed my mind.'
  },
  { // Vincent Chen
    id: '13',
    gender: 'm',
    name: 'Vincent Chen',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: vincentchenheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/vincentchen415/',
    resume: 'https://drive.google.com/file/d/1f99mpoyLa3GTPV-dlwEeZe_cHnH9n3gF/view?usp=sharing',
    campusInvolvement: 'PROVE, ASME, KASA, CSA',
    experience: [],
    interestHobbies: 'Tennis, Rock Climbing, Hiking',
    funFact: 'I have a scar from chopsticks!'
  },
  { //Gabriel Hyun
    id: '14',
    gender: 'm',
    name: 'Gabriel Hyun',
    major: ['Computer Science', 'CSC'],
    minor: 'Mathematics',
    headshot: gabrielhyunheadshot,
    class: 'Founding',
    linkedin: 'https://www.linkedin.com/in/gabrielhyun/',
    resume: 'https://drive.google.com/file/d/1wqyHUrlPXhKPB-v9-AdW5Tl3oZE2Cb3R/view?usp=sharing',
    campusInvolvement: 'Korean American Student Association',
    experience: [
      {year: '2020', company: 'Automation Anywhere', position: 'Software Engineering Intern (Frontend)'},
      {year: '2019', company: 'Automation Anywhere', position: 'Technical Marketing Intern'}
    ],
    interestHobbies: 'Gaming, Reading, Web Development',
    funFact: 'When I was 10 I fell down a flight of stairs!'
  },
  { // Jordan Ross
    id: '15',
    gender: 'f',
    name: 'Jordan Ross',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: jordanrossheadshot,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/jordan-c-ross/',
    resume: 'https://drive.google.com/file/d/1F4xzTJ3ibAumaPJo8MFFITWCBpd4Pm2O/view?usp=sharing',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Sabrina Nguyen
    id: '16',
    gender: 'f',
    name: 'Sabrina Nguyen',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: sabrinanguyenheadshot,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/sabrinnanguyen/',
    resume: 'https://drive.google.com/file/d/1oDrK7qqXnGtlUOJXiwJhNeAlYFQPY6Lt/view?usp=sharing',
    campusInvolvement: 'Cal Poly SWE (Society of Women Engineers)',
    experience: [
    ],
    interestHobbies: 'Going to concerts, Beaches, Art Exhibits, Playing Volleyball',
    funFact: 'I would like to think that I\'m psychic because I would have dreams or essentially a third eye telling me someting about the future and boom they turn out to be true.'
  },
  { // Caroline Pham
    id: '17',
    gender: 'f',
    name: 'Caroline Pham',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: carolinephamheadshot,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/caroline-pham-7a7132205/',
    resume: 'https://drive.google.com/file/d/1lcsN9lcLN0pip6kRW0sgRU02kort701E/view?usp=sharing',
    campusInvolvement: 'ASCE, SWE',
    experience: [
    ],
    interestHobbies: 'Basketball, Hiking, True Crime Shows, Cooking',
    funFact: 'I can juggle!'
  },
  { //Jadon Bradford
    id: '0',
    gender: 'm',
    name: 'Jadon Bradford',
    year: '2024',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: jbrhs,
    class: 'Alpha',
    linkedin: 'https://linkedin.com/in/jadonb',
    resume: 'https://drive.google.com/file/d/1xwdnw7njligEKbU9O5PGanvAYPjF0bGA/view?usp=sharing',
    campusInvolvement: 'Medical Design Club: electrolyte monitoring project, BMES, Theta Tau, GSR Student Assistant',
    experience: [
    ],
    interestHobbies: 'Volleyball, Medical Devices, Hiking, Cooking, Thrifting',
    funFact: 'I have a dog named dude, I can fit his whole fist in his mouth, I\'ve lived overseas my whole life'
  },
  { //Alexis DiGregorio
    id: '1',
    gender: 'f',
    name: 'Alexis DiGregorio',
    year: '2024',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: adhs,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/alexis-digregorio/',
    resume: 'https://drive.google.com/file/d/1WFzAoTyuBK7kty3-4gBUMCNCT8loIsvi/view?usp=sharing',
    campusInvolvement: 'Cal Poly Space Systems',
    experience: [],
    interestHobbies: 'Astronomy, Hiking, Reading',
    funFact: 'I love soccer!'
  }, 
  { //Skyler Han
    id: '2',
    gender: 'f',
    name: 'Skyler Han',
    year: '2024',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: shhs,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/skyler-han-cp/',
    resume: 'https://drive.google.com/file/d/1HVkjaew8ctR8qPFM-ffQiEVyG7P0zvCM/view?usp=sharing',
    campusInvolvement: 'Honors Program, KASA, WISH, Kappa Alpha Theta, Hack4Impact',
    experience: [
    ],
    interestHobbies: 'Embroidery, badminton, political Netflix shows, trashy reality shows, impulsively buying house plants at Home Depot',
    funFact: 'I\'ve lived in 4 different cities in the past 3 years'
  },
  { //Carlos Lopez
    id: '3',
    gender: 'm',
    name: 'Carlos Lopez',
    year: '2024',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: clhs,
    class: 'Alpha',
    linkedin: 'https://www.linkedin.com/in/carlos-lopez-98656a1a8/',
    resume: 'https://drive.google.com/file/d/1W0A2ZxRbFQvJu4QAkomH0osiLdafDy4O/view?usp=sharing',
    campusInvolvement: 'NSTP (Orientation Leadership Team), Resident Advisor, SHPE, TRIO',
    experience: [
    ],
    interestHobbies: 'Listening to music, Going on walks, Crocheting, Hanging out with friends',
    funFact: 'I have 6 siblings total in my family'
  },
  { // Noelle Marroquin
    id: '4',
    gender: 'f',
    name: 'Noelle Marroquin',
    year: '2024',
    major: ['Environmental Management', 'ENVM'],
    minor: 'City and Regional Planning',
    headshot: nmhs,
    class: 'Beta',
    linkedin: 'https://www.linkedin.com/in/noellemarroquin/',
    resume: 'https://drive.google.com/file/d/1UQWksDeubOMeqglmWd710JEbNxfxDhV5/view?usp=sharing',
    campusInvolvement: 'Engineers Without Borders - Fiji Team, CP Entrepreneurs - The Intrepid, CP Cat Shelter, CP Dean of Students, CP New Student and Transition Programs',
    experience: [],
    interestHobbies: 'Sustainability, Reading, Paddleboarding',
    funFact: 'I can legally use the prefix "Lady" before my name (Lady Noelle Monique Marroquin).'
  },
  { // Xaviera Pons
    id: '5',
    gender: 'f',
    name: 'Xaviera Pons',
    year: '2024',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: xphs,
    class: 'Beta',
    linkedin: 'https://www.linkedin.com/in/xaviera-pons-725130183/',
    resume: 'https://drive.google.com/file/d/12IWH0A5DShBjLoLaV9hp71Vw1uyiQR0h/view?usp=sharing',
    campusInvolvement: 'Theta Tau',
    experience: [ {year: '2021 - Present', company: 'Cal Poly EE Dept', position: 'Lab Assistant'} ],
    interestHobbies: 'Music, Fashion, Make-up, Fitness, Journaling, Documentaries, Tech',
    funFact: 'I have been playing billiards since I was tall enough to reach the table!'
  },
  { // Tana Risley
    id: '6',
    gender: 'f',
    name: 'Tana Risley',
    year: '2024',
    major: ['Civil Engineering', 'CE'],
    minor: 'Construction Management',
    headshot: trhs,
    class: 'Beta',
    linkedin: 'https://www.linkedin.com/in/tanarisley',
    resume: 'https://drive.google.com/file/d/1ivku7SToFSTn_Z7aDwieNqVd7zmA6Ulx/view?usp=sharing',
    campusInvolvement: 'Alpha Omicron Pi, Panhellenic, Mustang Scholars, Cal Poly Cat Program',
    experience: [
      {year: '2021', company: 'Stacy and Witbeck', position: 'Office & Field Engineering Intern'}
    ],
    interestHobbies: 'Hiking, Backpacking, Surfing',
    funFact: 'I have been skydiving!'
  },
  // { // Shannon Robinson
  //   id: '7',
  //   gender: 'f',
  //   name: 'Shannon Robinson',
  //   year: '2024',
  //   major: ['Mechanical Engineering', 'ME'],
  //   minor: '',
  //   headshot: srhs,
  //   class: 'Beta',
  //   linkedin: 'https://www.linkedin.com/in/syrobins/',
  //   resume: 'https://drive.google.com/file/d/1Ir4aNjS44oeDUZPWwjvLf1JCXvtIQzP9/view?usp=sharing',
  //   campusInvolvement: 'EMPOWER; Chinese Student Association; Pilipino Cultural Exchange',
  //   experience: [{year: '2021', company: 'Avantec Vascular Corporation', position: 'Manufacturing Engineering Intern'}],
  //   interestHobbies: 'Singing, Thrifting, Martial Arts, Hiking',
  //   funFact: 'My birthday is on Christmas :)'
  // },
  { // Bella Shaffer
    id: '8',
    gender: 'f',
    name: 'Bella Shaffer',
    year: '2024',
    major: ['Aerospace Engineering', 'AERO'],
    minor: 'Spanish',
    headshot: bshs,
    class: 'Beta',
    linkedin: 'https://www.linkedin.com/in/annabella-shaffer',
    resume: '',
    campusInvolvement: 'Cal Poly Space Systems',
    experience: [],
    interestHobbies: 'Paddleboarding, Skiing, Hiking',
    funFact: 'I dislocated my shoulder doing paddleboard yoga'
  },
  { // Reese Wheeler
    id: '9',
    gender: 'f',
    name: 'Reese Wheeler',
    year: '2024',
    major: ['Biomedical Engineering | bioinstrumentation', 'BMED'],
    minor: 'gender, race, culture, science, and technology',
    headshot: rwhs,
    class: 'Beta',
    linkedin: 'https://www.linkedin.com/in/reesewheeler',
    resume: rwr,
    campusInvolvement: 'SWE, MDC, BMES',
    experience: [
      {year: '2021', company: 'Tandem Diabetes Care', position: 'Mechanical Engineering Intern'},
      {year: '2018-2020', company: 'The Engineering Enterprise', position: 'Intern'}
    ],
    interestHobbies: 'Tennis, going to the beach, watching new shows/movies, taking fun trips',
    funFact: 'I love watching reality TV'
  },
  { // Nick Ghaffarian
    id: '11',
    gender: 'm',
    name: 'Nick Ghaffarian',
    year: '2024',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: nghs ,
    class: 'Gamma',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Jasmine Bueno
    id: '12',
    gender: 'f',
    name: 'Jasmine Bueno',
    year: '2025',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: jbuhs,
    class: 'Delta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },  
  { // Emily Vuong
    id: '19',
    gender: 'f',
    name: 'Emily Vuong',
    year: '2025',
    major: ['Industrial Engineering', 'IE'],
    minor: '',
    headshot: evhs,
    class: 'Delta',
    linkedin: '',
    resume: '',
    campusInvolvement: 'IISE (institute of industrial and systems engineers)',
    experience: [],
    interestHobbies: 'Reading, Tennis, Badminton, Ping Pong, Dance',
    funFact: 'I have a stuffed caterpillar plush as a car mascot!'
  },
  { // Aiden Phan
    id: '27', 
    gender: 'm',
    name: 'Aiden Phan',
    year: '2025',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: aphs,
    class: 'Epsilon',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Arianne Landers
    id: '33',
    gender: 'f',
    name: 'Arianne Landers',
    year: '2025',
    major: ['Industrial Engineering', 'IE'],
    minor: '',
    headshot: alhs,
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Nirali Patel
    id: '35',
    gender: 'f',
    name: 'Nirali Patel',
    year: '2026',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: '',
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Paige Read
    id: '28', 
    gender: 'f',
    name: 'Paige Read',
    gradyear: '2026',
    year: '5',
    major: ['BioMedical Engineering', 'BMED'],
    minor: '',
    headshot: prhs,
    class: 'Epsilon',
    linkedin: '',
    resume: '',
    campusInvolvement: 'EMPOWER, inCHAARG, Society of Women Engineers (SWE)',
    experience: [],
    interestHobbies: 'Volleyball, hiking, going to the beach, camping',
    funFact: 'I’ve played volleyball since I was 7!'
  },
  { // Evan Russell
    id: '29',
    gender: 'm',
    name: 'Evan Russell',
    gradyear: '2026',
    year: '4',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: erhs,
    class: 'Epsilon',
    linkedin: 'https://www.linkedin.com/in/evanmrussell1',
    resume: '',
    campusInvolvement: 'Tau Beta Pi Engineering Honor Society, Academic Tutoring',
    experience: [ ],
    interestHobbies: 'Dental Equipment, Surfing, Hiking, Mountain Biking, Skiing',
    funFact: 'Got struck by lightening while mountaineering'
  },
  { // Suhanth Alluri
    id: '31',
    gender: 'm',
    name: 'Suhanth Alluri',
    gradyear: '2026',
    year: '4',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: salhs,
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: 'Computers, Outdoors/Nature, F1',
    funFact: 'I am a Jr. Software Developer at Amazon'
  },
  { // Maxwell Silver
    id: '36',
    gender: 'f',
    name: 'Maxwell Silver',
    gradyear: '2026',
    year: '4',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: mshs,
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: 'Pilipino Cultural Exchange, University Honors Program',
    experience: [ ],
    interestHobbies: 'Playing pool, learning languages, owning plants, thrifting',
    funFact: 'I met Grant Perez'
  },
  { // Will Toll
    id: '37',
    gender: 'm',
    name: 'Will Toll',
    gradyear: '2026',
    year: '5',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: wths,
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: 'oSTEM, EMPOWER, Medical Design Club',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Abigail Carter
    id: '100',
    gender: 'f',
    name: 'Abigail Carter',
    gradyear: '2026',
    year: '4',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: achs2,
    class: 'Delta',
    linkedin: 'https://www.linkedin.com/in/abigail-carter4?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    resume: '',
    campusInvolvement: 'I am the Student Safety Tech for the Aero Department, I work at Cal Poly Partners doing work on the hypersonic wind tunnel, I’m doing a project with NTPS, and I interned at Anduril',
    experience: [],
    interestHobbies: 'Volleyball, reading, going to gym, planes',
    funFact: 'I have moved 8 times and lived in 5 states.'
  },
  { // Sakiko Pizzorno
    id: '101',
    gender: 'f',
    name: 'Sakiko Pizzorno',
    gradyear: '2026',
    year: '4',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: sphs,
    class: 'Delta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Caden Upson
    id: '102',
    gender: 'm',
    name: 'Caden Upson',
    gradyear: '2026',
    year: '4',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: cuhs,
    class: 'Delta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Shafiq Amat
    id: '103',
    gender: 'm',
    name: 'Shafiq Amat',
    gradyear: '2026',
    year: '4',
    major: ['Mechanical Engineering', 'ME'],
    minor: 'Computer Science',
    headshot: sahs,
    class: 'Epsilon',
    linkedin: 'https://www.linkedin.com/in/shafiq-amat/',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Dominique Giang
    id: '104',
    gender: 'm',
    name: 'Dominique Giang',
    gradyear: '2026',
    year: '5',
    major: ['Architectural Engineering', 'ARCE'],
    minor: '',
    headshot: dghs,
    class: 'Epsilon',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Ava Ngo
    id: '105',
    gender: 'f',
    name: 'Ava Ngo',
    gradyear: '2026',
    year: '4',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: anhs,
    class: 'Epsilon',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Izabella Parga
    id: '106',
    gender: 'f',
    name: 'Izabella Parga',
    gradyear: '2026',
    year: '4',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: iphs,
    class: 'Epsilon',
    linkedin: '',
    resume: '',
    campusInvolvement: 'SWE and EMPOWER',
    experience: [],
    interestHobbies: 'Prosthetics and Baseball',
    funFact: ''
  },
  { // Jodi Yamane
    id: '107',
    gender: 'f',
    name: 'Jodi Yamane',
    gradyear: '2026',
    year: '4',
    major: ['Computer science', 'CSC'],
    minor: '',
    headshot: jyhs,
    class: 'Epsilon',
    linkedin: 'http://linkedin.com/in/jodi-yamane-615708253',
    resume: jyr,
    campusInvolvement: 'Hui o Hawaii, Hack4Impact',
    experience: [],
    interestHobbies: 'Beach, music, volleyball',
    funFact: 'I did 6 sports when I was younger (not well, though)'
  },
  { // Renee Rebolledo
    id: '108',
    gender: 'f',
    name: 'Renee Rebolledo',
    gradyear: '2026',
    year: '4',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: '',
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Alex Valenzano
    id: '109',
    gender: 'f',
    name: 'Alex Valenzano',
    gradyear: '2026',
    year: '4',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: alexvalenzanoheadshot2,
    class: 'Zeta',
    linkedin: 'https://www.linkedin.com/in/avalenzano?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    resume: '',
    campusInvolvement: 'Cal Poly Wind Power , Skip The Grid, undergraduate research, instructional student assistant',
    experience: [ ],
    interestHobbies: 'Reading, running, crocheting',
    funFact: ''
  },
  { // Matthew Suban
    id: '110',
    gender: 'm',
    name: 'Matthew Suban',
    gradyear: '2026',
    year: '4',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: msuhs,
    class: 'Eta',
    linkedin: 'www.linkedin.com/in/msuban05',
    resume: '',
    campusInvolvement: 'Cal Poly Esports, Photography',
    experience: [ ],
    interestHobbies: 'Swimming, Cinematography/Vlogging',
    funFact: ''
  },
  { // Devlin Knill
    id: '111',
    gender: 'm',
    name: 'Devlin Knill',
    gradyear: '2026',
    year: '4',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: dkhs,
    class: 'Eta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
];
export const brothers = [

  // { // Raquel Fujita
  //   id: '14',
  //   gender: 'f',
  //   name: 'Raquel Fujita',
  //   year: '2026',
  //   major: ['Civil Engineering', 'CE'],
  //   minor: '',
  //   headshot: rfhs,
  //   class: 'Delta',
  //   linkedin: '',
  //   resume: '',
  //   campusInvolvement: '',
  //   experience: [],
  //   interestHobbies: '',
  //   funFact: ''
  // },
  // { // Jack Devereux
  //   id: '22', 
  //   gender: 'm',
  //   name: 'Jack Devereux',
  //   year: '2026',
  //   major: ['General Engineering', 'GE'],
  //   minor: '',
  //   headshot: jdhs,
  //   class: 'Epsilon',
  //   linkedin: '',
  //   resume: '',
  //   campusInvolvement: '',
  //   experience: [],
  //   interestHobbies: '',
  //   funFact: ''
  // },
  { // Akhila Donthi
    id: '32',
    gender: 'f',
    name: 'Akhila Donthi',
    gradyear: '2027',
    year: '3',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: akhiladonthiheadshot,
    class: 'Zeta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },

  { // Anna Wilson
    id: '38',
    gender: 'f',
    name: 'Anna Wilson',
    gradyear: '2027',
    year: '3',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: annawilsonheadshot,
    class: 'Zeta',
    linkedin: 'https://www.linkedin.com/in/annawilsonn27',
    resume: '',
    campusInvolvement: 'Cal Poly Welding Teacher Assistant, SWE, Jazz Combos, Infrasound Effects on Embers Senior Project',
    experience: [ ],
    interestHobbies: 'Travel, renewable energy, music performance, animals and nature, volleyball, and dance!',
    funFact: 'Post study abroad with Mechanics in Rome Fall 2024, I volunteered at a Monkey Sanctuary in Cornwall, England for winter break!'
  },
  // Hong Dang
  {
    id: '41',
    gender: 'f',
    name: 'Hong Dang',
    gradyear: '2027',
    year: '3',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: hdhs,
    class: 'Eta',
    Board: 'True',
    Position: 'Regent',
    linkedin: 'linkedin.com/in/hongntdang/',
    resume: 'https://drive.google.com/open?id=1F0DD90CVvXQ_CtJvLoCfqiDi8sh_QAqF',
    campusInvolvement: 'EMPOWER, ME Department Shop Tech',
    experience: [ ],
    interestHobbies: 'Cooking, crafting, trying new restaurants',
    funFact: 'I\'ve been to 50+ concerts'
  },
{ // Claire Riss
    id: '42',
    gender: 'f',
    name: 'Claire Riss',
    gradyear: '2027',
    year: '3',
    major: ['Industrial Engineering', 'IME'],
    minor: '',
    headshot: crhs,
    class: 'Eta',
    Board: 'True',
    Position: 'Corresponding Secretary',
    linkedin: 'https://www.linkedin.com/in/claire-riss-78753729a/',
    resume: 'https://drive.google.com/open?id=1uCPfHRzEhgPZtSE_jtXbUFzVrKoWuAur',
    campusInvolvement: 'Systems Optimization Club',
    experience: [ ],
    interestHobbies: 'Singing/playing the piano, taking pictures/making collages, hanging out with friends and exploring new coffee spots',
    funFact: 'I can play the Piano Man solo on harmonica (not as good as Billy of course).'
  }, 
  { // Parker Evans
    id: '43',
    gender: 'f',
    name: 'Parker Evans',
    gradyear: '2028',
    year: '2',  
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: pehs,
    class: 'Eta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  }, 
  { // Dev Amudala
    id: '44',
    gender: 'm',
    name: 'Dev Amudala',
    gradyear: '2027',
    year: '3',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: dahs,
    class: 'Eta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  }, 
  { // Chris Hawley
    id: '45',
    gender: 'm',
    name: 'Chris Hawley',
    gradyear: '2028',
    year: '2',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: chhs,
    class: 'Eta',
    AppointedBoard: 'True',
    AppointedPosition: 'Historian',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Alonzo Edwards
    id: '46',
    gender: 'm',
    name: 'Alonzo Edwards',
    gradyear: '2028',
    year: '2',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: aehs,
    class: 'Eta',
    AppointedBoard: 'True',
    AppointedPosition: 'Brotherhood Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Ana Prasad
    id: '47',
    gender: 'f',
    name: 'Ana Prasad',
    gradyear: '2028',
    year: '2',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: aprhs,
    class: 'Eta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Vinayak Kohli
    id: '49',
    gender: 'm',
    name: 'Vinayak Kohli',
    gradyear: '2028',
    year: '2',
    major: ['Software Engineering', 'SE'],
    minor: '',
    headshot: vinayakkohliheadshot,
    class: 'Eta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  // { // Adil Iftikhar
  //   id: '50',
  //   gender: 'm',
  //   name: 'Adil Iftikhar',
  //   year: '2027',
  //   major: ['Electrical Engineering', 'EE'],
  //   minor: '',
  //   headshot: '',
  //   class: 'Eta',
  //   linkedin: '',
  //   resume: '',
  //   campusInvolvement: '',
  //   experience: [ ],
  //   interestHobbies: '',
  //   funFact: ''
  // },
  { // Carlos Manzano
    id: '51',
    gender: 'm',
    name: 'Carlos Manzano',
    gradyear: '2027',
    year: '2',
    major: ['Computer Engineering', 'CPE'],
    minor: '',
    headshot: carlosmanzanoheadshot,
    class: 'Eta',
    AppointedBoard: 'True',
    AppointedPosition: 'Recruitment Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Yaneli Cruz
    id: '53',
    gender: 'f',
    name: 'Yaneli Cruz',
    gradyear: '2027',
    year: '3',
    major: ['Software Engineering', 'SE'],
    minor: '',
    headshot: yanelicruzheadshot2,
    class: 'Theta',
    Board: 'True',
    Position: 'Recording Secretary',
    linkedin: 'https://www.linkedin.com/in/yaneli-ava-cruz/',
    resume: 'https://drive.google.com/open?id=1bUnrpQZdZxJzQidniCDRphaONlgjLDtw',
    campusInvolvement: 'Other Clubs: Women Involved In Software and Hardware (WISH) - Tech Officer Color Coded by ColorStack - Social Media Manager Internship: County of San Luis Obispo, Department of Social Services - Operations Lead Intern for the Point-in-Time Count Research: Believe, Educate & Empower, Advocate, Collaborate, Nurture (BEACoN) Research Scholar - Spring 2026 Summer Undergraduate Research Program (SURP) Scholar - Summer 2025',
    experience: [ ],
    interestHobbies: 'Reading, going to the beach, driving, doom scrolling, gaming with friends and cousins, instigating',
    funFact: 'I\'ve met Tyler, the Creator!'
  },
  { // Stephanie Jovel
    id: '54',
    gender: 'f',
    name: 'Stephanie Jovel',
    gradyear: '2027',
    year: '3',
    major: ['Computer Engineering', 'CPE'],
    minor: '',
    headshot: stephaniejovelheadshot,
    class: 'Theta',
    linkedin: 'https://www.linkedin.com/in/stephanie-jovel-1851ba1b4',
    resume: '',
    campusInvolvement: 'SHPE, work',
    experience: [ ],
    interestHobbies: 'Hiking , arts and crafts, gym, beach, hanging out with friends',
    funFact: 'I’ve only broken my arm once in my entire life'
  },
  { // Matthew Jurado
    id: '55',
    gender: 'm',
    name: 'Matthew Jurado',
    gradyear: '2027',
    year: '3',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: '',
    class: 'Theta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Bella Rivera
    id: '56',
    gender: 'f',
    name: 'Bella Rivera',
    gradyear: '2028',
    year: '2',
    major: ['Industrial Engineering', 'IE'],
    minor: '',
    headshot: brhs,
    class: 'Theta',
    Board: 'True',
    Position: 'Vice Regent',
    linkedin: 'https://www.linkedin.com/in/bella-rivera-3362212a3?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    resume: '',
    campusInvolvement: 'SOC (systems optimization club), supply chain intern (currently @ ITW global tire repair), industrial engineering internship (technip FMC)',
    experience: [ ],
    interestHobbies: 'I love working out, watching sunsets, doing Bible studies, self care',
    funFact: 'I graduated with my Associates degree at the same time I graduated high school in Industrial Automation Engineering'
  },
  { // Samuel Rodriguez
    id: '57',
    gender: 'm',
    name: 'Samuel Rodriguez',
    gradyear: '2028',
    year: '2',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: samrodriguezheadshot,
    class: 'Theta',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Alexa Zamora
    id: '58',
    gender: 'f',
    name: 'Alexa Zamora Ambriz',
    gradyear: '2028',
    year: '2',
    major: ['Architectural Engineering', 'ARCE'],
    minor: '',
    headshot: alexazamoraheadshot,
    class: 'Theta',
    AppointedBoard: 'True',
    AppointedPosition: 'Professional Development Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  },
  { // Maiya Armstrong
    id: '59',
    gender: 'f',
    name: 'Maiya Armstrong',
    gradyear: '2028',
    year: '2',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: mahs,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Engineering Project Manager',
    linkedin: 'https://www.linkedin.com/in/maiya-armstrong-ba42bb300/',
    resume: '',
    campusInvolvement: 'Clubs: Women in Electrical Engineering, Poly UAS, Society of Women Engineers',
    experience: [],
    interestHobbies: 'Piano, Surfing, Working Out, Watercolor, Reading',
    funFact: 'I was a Girl Scouts for 10+ years!'
  },
  { // Katherine Bicocca
    id: '60',
    gender: 'f',
    name: 'Katherine Bicocca',
    gradyear: '2027',
    year: '3',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: kbhs,
    class: 'Iota',
    Board: 'True',
    Position: 'Marshal',
    linkedin: 'https://www.linkedin.com/in/kbicocca/',
    resume: '',
    campusInvolvement: 'Society of Women Engineers, internship at Ripple Medical',
    experience: [],
    interestHobbies: 'Reading, Pickleball, Soccer, Video Games',
    funFact: 'I collect miniature glass animals and they are adorable.'
  },
  { // Allegra Ciarlantini
    id: '61',
    gender: 'f',
    name: 'Allegra Ciarlantini',
    gradyear: '2029',
    year: '1',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: allegraciarlantiniheadshot,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Professional Development Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Thomas Costa
    id: '62',
    gender: 'm',
    name: 'Thomas Costa',
    gradyear: '2029',
    year: '1',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: tchs,
    class: 'Iota',
    Board: 'True',
    Position: 'Treasurer',
    linkedin: 'https://www.linkedin.com/in/thomas-costa-0bb639388',
    resume: 'https://drive.google.com/open?id=1eO7160NcQR-Ul1Df4YNYhTGRL-32jfox',
    campusInvolvement: 'I am currently am a research student for Dr. Kristen Cardinal, I am a member of EMPOWER, and I hope to pursue a job while continuing my education.',
    experience: [],
    interestHobbies: 'I love to go running, hiking, or do anything outdoors. I love to watch movies of all kinds, and I occasionally like to play video games.',
    funFact: 'A fun fact about me is that I have a second degree black belt in taekwondo.'
  },
  { // Ava Dornseif
    id: '63',
    gender: 'f',
    name: 'Ava Dornseif',
    gradyear: '2029',
    year: '1',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: '',
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Service Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Cole Hopp
    id: '64',
    gender: 'm',
    name: 'Cole Hopp',
    gradyear: '2029',
    year: '1',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: colehoppheadshot,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Service Chair',
    linkedin: 'https://www.linkedin.com/in/cole-hopp',
    resume: 'https://drive.google.com/open?id=1CGoNE5XBa-03vh88Wck2prz_m1DA-M0t',
    campusInvolvement: 'Society of Civil Engineering and Pickleball Club',
    experience: [],
    interestHobbies: 'Soccer, Pickleball, Hiking, and Cooking',
    funFact: 'I ate alpaca tacos in Peru!'
  },
  { // Jack Isola
    id: '65',
    gender: 'm',
    name: 'Jack Isola',
    gradyear: '2029',
    year: '1',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: jihs,
    class: 'Iota',
    linkedin: 'https://www.linkedin.com/in/jack-isola-357ba8340?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    resume: '',
    campusInvolvement: 'SCE, McCarthy Construction Companies',
    experience: [],
    interestHobbies: 'Working out, video games, sports',
    funFact: 'I have owned three pufferfish'
  },
  { // Nicole Kaldas
    id: '66',
    gender: 'f',
    name: 'Nicole Kaldas',
    gradyear: '2028',
    year: '2',
    major: ['Electrical Engineering', 'EE'],
    minor: '',
    headshot: nkhs,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Recruitment Chair',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Chris Morales
    id: '67',
    gender: 'm',
    name: 'Chris Morales',
    gradyear: '2027',
    year: '3',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: '',
    class: 'Iota',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Miranda Reyes
    id: '68',
    gender: 'f',
    name: 'Miranda Reyes',
    gradyear: '2028',
    year: '2',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: mirandareyesheadshot,
    class: 'Iota',
    linkedin: 'https://www.linkedin.com/in/miranda-paulette-reyes',
    resume: '',
    campusInvolvement: 'Cal Poly Scholars, SWE, PROVE',
    experience: [],
    interestHobbies: 'Volleyball, hiking, trying new foods/places.',
    funFact: 'I collect my energy drink tabs to see how much energy drinks I’ve taken throughout my engineering degree'
  },
  { // Marilin Rodriguez
    id: '69',
    gender: 'f',
    name: 'Marilin Rodriguez',
    gradyear: '2028',
    year: '2',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: marilinrodriguezheadshot,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Media and Design Chair',
    linkedin: 'https://www.linkedin.com/in/marilinrodriguez?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    resume: '',
    campusInvolvement: 'Empower',
    experience: [],
    interestHobbies: 'Hiking, Painting, Drawing, Crafting',
    funFact: 'I have a fixation on little things, so I tend to craft for my calico critters on my spare time.'
  },
  { // Gabrielle Sands
    id: '70',
    gender: 'f',
    name: 'Gabrielle Sands',
    gradyear: '2028',
    year: '2',
    major: ['BioResource and Agricultural Engineering', 'BRAE'],
    minor: '',
    headshot: gshs,
    class: 'Iota',
    linkedin: 'http://www.linkedin.com/in/gabriellesands',
    resume: '',
    campusInvolvement: 'Aquaculture Research Assistant, Young Life, Agricultural Engineering Society (AES)',
    experience: [],
    interestHobbies: 'Golf, crafting, cooking, and baking',
    funFact: 'I collect rubber ducks 🦆'
  },
  { // Nimisha Thakur
    id: '71',
    gender: 'f',
    name: 'Nimisha Thakur',
    gradyear: '2028',
    year: '2',
    major: ['Software Engineering', 'SE'],
    minor: '',
    headshot: nimishathakurheadshot2,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Diversity, Equity, and Inclusion Chair',
    linkedin: 'https://www.linkedin.com/in/nimisha-thakur-',
    resume: 'https://drive.google.com/open?id=10V7KSSz-QM1cT83BmRlXwrh7iQjhf5KT',
    campusInvolvement: 'ASI Student Government, Society of Women Engineers, Indian Student Association',
    experience: [],
    interestHobbies: 'Martial Arts, Concerts, Hiking, Beach, Going to the movies, Baking',
    funFact: 'One time I saw a shark washed up on the beach!'
  },
  { // Bryce Wang
    id: '72',
    gender: 'm',
    name: 'Bryce Wang',
    gradyear: '2027',
    year: '3',
    major: ['Computer Engineering', 'CPE'],
    minor: '',
    headshot: brycewangheadshot,
    class: 'Iota',
    linkedin: 'https://www.linkedin.com/in/bryce-wang',
    resume: 'https://drive.google.com/open?id=11sN1HJSbJfH87eowEHckrbYwvoXxVZZz',
    campusInvolvement: 'Epic',
    experience: [],
    interestHobbies: 'Ultimate Frisbee, Volleyball, Basketball, Soccer, Drawing',
    funFact: 'I am friends with Rob Pelinka\'s (GM of the Lakers) son'
  },
  { // Izzy Zastrow
    id: '73',
    gender: 'f',
    name: 'Izzy Zastrow',
    gradyear: '2029',
    year: '1',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: izhs,
    class: 'Iota',
    AppointedBoard: 'True',
    AppointedPosition: 'Risk Management Chair',
    linkedin: 'https://www.linkedin.com/in/izzy-zastrow/',
    resume: 'https://drive.google.com/open?id=1nEow_0qEUXOqHt5T7uxvDP5lCekHwHRO',
    campusInvolvement: 'Sales in Engineering Club, Society of Women Engineers',
    experience: [],
    interestHobbies: 'Working out, hiking, and reading.',
    funFact: 'I have my private pilot license!'
  },
  { // Barrett Abena
    id: '74',
    gender: 'm',
    name: 'Barrett Abena',
    gradyear: '2029',
    year: '1',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: bahs,
    class: 'Kappa',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Zack Adzich
    id: '75',
    gender: 'm',
    name: 'Zack Adzich',
    gradyear: '2029',
    year: '1',
    major: ['Mechanical Engineering', 'ME'],
    minor: '',
    headshot: zackadzichheadshot,
    class: 'Kappa',
    linkedin: 'https://www.linkedin.com/in/zadzich/',
    resume: '',
    campusInvolvement: 'EMPOWER, SAMPE',
    experience: [],
    interestHobbies: 'Running, Hiking, Pickleball',
    funFact: 'I\'ve bowled a turkey at Mustang Lanes!'
  },
  { // Noemi Alatorre
    id: '76',
    gender: 'f',
    name: 'Noemi Alatorre',
    gradyear: '2029',
    year: '1',
    major: ['Materials Engineering', 'MATE'],
    minor: '',
    headshot: noemialatorreheadshot,
    class: 'Kappa',
    linkedin: 'https://www.linkedin.com/in/noemi-alatorre-0792753a6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    resume: '',
    campusInvolvement: 'Tikkun Olam',
    experience: [],
    interestHobbies: 'Reading, Swimming, Thrifting',
    funFact: 'I’ve milked a cow before'
  },
  { // Belle Brensel
    id: '77',
    gender: 'f',
    name: 'Belle Brensel',
    gradyear: '2029',
    year: '1',
    major: ['General Engineering', 'GE'],
    minor: '',
    headshot: '',
    class: 'Kappa',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Karolina Gutierrez
    id: '78',
    gender: 'f',
    name: 'Karolina Gutierrez',
    gradyear: '2029',
    year: '1',
    major: ['Civil Engineering', 'CE'],
    minor: '',
    headshot: kghs,
    class: 'Kappa',
    linkedin: 'www.linkedin.com/in/karolinagutierrez1077',
    resume: 'https://drive.google.com/open?id=1-anY-9HDaOzeEmntwT2Tg-dHBLiE2WVu',
    campusInvolvement: 'ASCE, Port of Los Angeles',
    experience: [],
    interestHobbies: "Trying new food, Running, Cooking, Softball",
    funFact: 'I have a twin sister!'
  },
  { // Snehil Kakani
    id: '79',
    gender: 'm',
    name: 'Snehil Kakani',
    gradyear: '2029',
    year: '1',
    major: ['Computer Science', 'CSC'],
    minor: '',
    headshot: snehilkakaniheadshot,
    class: 'Kappa',
    AppointedBoard: 'True',
    AppointedPosition: 'Web Development Chair',
    linkedin: 'https://linkedin.com/in/snehilkakani',
    resume: 'https://snehilkakani.me/resume.pdf',
    campusInvolvement: 'Hack4Impact, CodeBox, ISA',
    experience: [],
    interestHobbies: 'Music production, photography, gaming',
    funFact: 'My friend is a rapper and I’m a producer and we’ve made a ton of songs together'
  },
  { // Sophia McCartney
    id: '80',
    gender: 'f',
    name: 'Sophia McCartney',
    gradyear: '2029',
    year: '1',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: sophiamccartneyheadshot,
    class: 'Kappa',
    linkedin: 'https://www.linkedin.com/in/sophia-mccartney',
    resume: 'https://drive.google.com/open?id=1o4QCL3rdNzx1j4dwKiDUE2rE_1tbc0jV',
    campusInvolvement: 'Tikkun Olam',
    experience: [],
    interestHobbies: 'Running and Painting!',
    funFact: 'I\'ve kept chickens, snakes, and lizards as pets, but never dogs or cats.'
  },
  { // Naomi Sabes
    id: '81',
    gender: 'f',
    name: 'Naomi Sabes',
    gradyear: '2028',
    year: '2',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: nshs,
    class: 'Kappa',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Seth Poulter
    id: '82',
    gender: 'm',
    name: 'Seth Poulter',
    gradyear: '2028',
    year: '2',
    major: ['Aerospace Engineering', 'AERO'],
    minor: '',
    headshot: sphs2,
    class: 'Kappa',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  { // Monica Sebastian
    id: '83',
    gender: 'f',
    name: 'Monica Sebastian',
    gradyear: '2029',
    year: '1',
    major: ['Biomedical Engineering', 'BMED'],
    minor: '',
    headshot: mshs2,
    class: 'Kappa',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [],
    interestHobbies: '',
    funFact: ''
  },
  /*
  { // name
    id: '',
    gender: '',
    name: '',
    gradyear: '',
    year: '',
    major: ['', ''],
    minor: '',
    headshot: ,
    class: '',
    linkedin: '',
    resume: '',
    campusInvolvement: '',
    experience: [ ],
    interestHobbies: '',
    funFact: ''
  }
  */
];

export default brothers && Alum;

// Will Toll = Position:'Corresponding Secretary',


// HAHAH LOSER GOTTA ADD ANOTHER CLASS AND HUNT DOWN ETA